import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {translate} from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class AppHttpInterceptor implements HttpInterceptor {

  private readonly REDIRECTION_STATUS_CODE: number = 302;
  private readonly UNAUTHORIZED_STATUS_CODE: number = 401;
  private readonly FORBIDDEN_STATUS_CODE: number = 403;
  private readonly NOT_FOUND_CODE: number = 404;
  private readonly SERVER_ERROR_CODE: number = 500;
  private readonly GATEWAY_TIMEOUT_ERROR_CODE: number = 504;
  private readonly ZERO_STATUS_CODE: number = 0;

  constructor(private oauthService: OAuthService,
              private messageService: MessageService,
              private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(map(resp => {
        if (resp instanceof HttpResponse) {
          return resp;
        }

      }),
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          this.filterTimeouts(err);
        }
        return throwError(err);
      }));
  }

  private filterTimeouts(errorResponse: HttpErrorResponse): void {

    if (errorResponse.status === this.UNAUTHORIZED_STATUS_CODE
      || errorResponse.status === this.REDIRECTION_STATUS_CODE
      || errorResponse.status === this.ZERO_STATUS_CODE) {
      this.oauthService.initLoginFlow();
    }
    if (errorResponse.status === this.FORBIDDEN_STATUS_CODE) {
      this.router.navigate(['/not-authorized']);
    }
    if (errorResponse.status === this.NOT_FOUND_CODE) {
      let summary = translate('error.summary.unexpected');
      let detail = translate('error.http.notFound');
      this.messageService.add({severity: 'error', summary: summary, detail: detail, sticky: true});
    }
    if (errorResponse.status === this.SERVER_ERROR_CODE) {
      let summary = translate('error.summary.unexpected');
      let detail = translate('error.http.serverError');
      this.messageService.add({severity: 'error', summary: summary, detail: detail, sticky: true});
    }
    if (errorResponse.status === this.GATEWAY_TIMEOUT_ERROR_CODE) {
      let summary = translate('error.summary.unexpected');
      let detail = translate('error.http.timeout');
      this.messageService.add({severity: 'error', summary: summary, detail: detail, sticky: true});
    }
  }

  isHttpCodeFiltered(httpCode: number): boolean {
    for (const key of Object.keys(this)) {
      if (this[key] === httpCode) {
        return true;
      }
    }

    return false;
  }

}
